export default value => {
  const date = new Date(0)
  date.setSeconds(value)
  const timeString = date.toISOString().substr(11, 8)
  return timeString
}
